// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1qILY","label":"Completed_label__2uUPW"};